import type { Locale } from './i18n/index';

/**
 * TMDB's movie genre list. Stored as ids on the movie so the collection is
 * language-neutral; the label is resolved at render time.
 *
 * Source: TMDB `/genre/movie/list` for en-US and de-DE. This list is stable —
 * TMDB has not changed it in years — so it is inlined rather than fetched.
 */
export const GENRES: Record<number, { en: string; de: string }> = {
  28: { en: 'Action', de: 'Action' },
  12: { en: 'Adventure', de: 'Abenteuer' },
  16: { en: 'Animation', de: 'Animation' },
  35: { en: 'Comedy', de: 'Komödie' },
  80: { en: 'Crime', de: 'Krimi' },
  99: { en: 'Documentary', de: 'Dokumentarfilm' },
  18: { en: 'Drama', de: 'Drama' },
  10751: { en: 'Family', de: 'Familie' },
  14: { en: 'Fantasy', de: 'Fantasy' },
  36: { en: 'History', de: 'Historie' },
  27: { en: 'Horror', de: 'Horror' },
  10402: { en: 'Music', de: 'Musik' },
  9648: { en: 'Mystery', de: 'Mystery' },
  10749: { en: 'Romance', de: 'Liebesfilm' },
  878: { en: 'Science Fiction', de: 'Science Fiction' },
  10770: { en: 'TV Movie', de: 'TV-Film' },
  53: { en: 'Thriller', de: 'Thriller' },
  10752: { en: 'War', de: 'Kriegsfilm' },
  37: { en: 'Western', de: 'Western' },
};

export function genreName(id: number, locale: Locale): string | null {
  return GENRES[id]?.[locale] ?? null;
}

export function genreNames(ids: number[], locale: Locale): string[] {
  return ids.map((id) => genreName(id, locale)).filter((name): name is string => name !== null);
}

export const ALL_GENRE_IDS: number[] = Object.keys(GENRES).map(Number);
